import { useEffect } from 'react';
import { useNavigate, useRouterState } from '@tanstack/react-router';

import { SETTINGS_PATH } from '../copy';

/**
 * Old links to the settings (spec 142 US1). An email's "Notification
 * settings" link lands on `?settings=notifications` (service spec 119), from
 * when the settings were a dialog with no address; it now goes to their page,
 * replacing the entry so Back does not return to the parameter.
 */
export function SettingsLinkRedirect() {
  const navigate = useNavigate();
  const asked = useRouterState({
    select: (state) =>
      new URLSearchParams(state.location.searchStr).get('settings') ===
      'notifications',
  });
  useEffect(() => {
    if (asked) void navigate({ to: SETTINGS_PATH, replace: true });
  }, [asked, navigate]);
  return null;
}
